export function sendMessageGW1({ action, payload }) {
  const message = {
    app: 'gioweb2',
    action,
    payload,
  };
  window.parent.postMessage(JSON.stringify(message), '*');
}
export function sendCloseMessageGW1(payload) {
  sendMessageGW1({ action: 'CLOSE_WINDOW', payload });
}
export function sendSetTilteGW1(payload) {
  sendMessageGW1({ action: 'TITLE_CHANGE', payload });
}
